module.exports = __webpack_public_path__ + "img/pt_tx.78d497cb.png";